import { Navigate, RouteObject } from 'react-router-dom';

import Home from '../../app/Home.tsx';
import Layout from '../../app/Layout.tsx';
import { RouteError } from './RouteError.tsx';
import {
  AccessDeniedRouteItem,
  AccountManagementItems,
  LoginRouteItem,
  LoginTwoFactorRouteItem,
  MyAccountItem
} from './SectionRoutes/AccountRoutes.tsx';
import { AdminNavItems } from './SectionRoutes/AdminRoutes.tsx';
import { AgentEmailNavItems } from './SectionRoutes/AgentEmailRoutes.tsx';
import {
  AgentQuerySubItems,
  HotelSearchNavItem,
  ThirdPartyPaymentDetailsItem
} from './SectionRoutes/AgentQueryRoutes.tsx';
import { CrmNavItems } from './SectionRoutes/CrmRoutes.tsx';
import { FolioNavItems } from './SectionRoutes/FolioRoutes.tsx';
import { GroupNavItems } from './SectionRoutes/GroupRoutes.tsx';
import { ReportingNavItems } from './SectionRoutes/ReportingRoutes.tsx';
import { BaseNav, buildNavItemFromRoute, buildRoute, useNavItemStore } from '@cks-internal/react-base';
import { FrontierAccessDenied } from '../../app/routes/FrontierAccessDenied.tsx';
import { MirNavItems } from 'src/app/routes/SectionRoutes/MirRoutes.tsx';

const AuthenticatedRouteItems = [
  HotelSearchNavItem,
  AgentQuerySubItems,
  AgentEmailNavItems,
  ReportingNavItems,
  FolioNavItems,
  CrmNavItems,
  GroupNavItems,
  MirNavItems,
  AdminNavItems,
  MyAccountItem,
  AccountManagementItems
];
const UnauthenticatedRouteItems = [
  LoginRouteItem,
  LoginTwoFactorRouteItem,
  AccountManagementItems,
  AccessDeniedRouteItem,
  ThirdPartyPaymentDetailsItem
];

export function useNavWithRouting() {
  const routes = new Array<RouteObject>();
  const nav: BaseNav.NavItem[] = [];
  const setNavItemStore = useNavItemStore((state) => state.set);

  routes.push({
    path: '/',
    element: <Layout />,
    errorElement: <RouteError />,
    children: [{ path: '/', element: <Home />, errorElement: <RouteError /> }]
  });

  AuthenticatedRouteItems.forEach((value) => {
    routes.push(buildRoute(value, <FrontierAccessDenied />));
    const navItem = buildNavItemFromRoute(value);
    if (navItem) {
      nav.push(navItem);
    }
  });

  UnauthenticatedRouteItems.forEach((value) => {
    routes.push(buildRoute(value));
    const navItem = buildNavItemFromRoute(value);
    if (navItem) {
      nav.push(navItem);
    }
  });

  routes.push({
    path: '/spa/*',
    element: <Navigate to={window.location.pathname.toString().replace('/spa', '')} replace />
  });

  setNavItemStore(nav);
  return routes;
}
